import { Component, OnInit } from '@angular/core';
import { KTheme } from 'ng-k-styles';
import { IKSideNavItem } from 'ng-k-side-bar';
import { Router } from '@angular/router';

@Component({
  selector: 'app-claims-insights-container',
  templateUrl: './claims-insights-container.component.html',
  styleUrls: ['./claims-insights-container.component.scss']
})
export class ClaimsInsightsContainerComponent implements OnInit {
  public theme = KTheme;
  public isSideBarOpen: boolean = true;
  navItems: IKSideNavItem[];

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
    const navItems: IKSideNavItem[] = [
      {
        icon: { type: 'fas', name: 'user'},
        label: 'Know Your Opponent',
        routerLink: ['/insights/report']
      },
      // {
      //   icon: { type: 'fas', name: 'file'},
      //   label: 'My Claims',
      //   routerLink: ['/claims']
      // },
    ];

    this.navItems = navItems;
  }

  handleSideBarToggle(event: any) {
    // handle toggle event here
    this.isSideBarOpen = event;
  }


}
